import { createContext, useState } from 'react';
import { getStartOfWeek } from '../helper/date-helper';

export interface CalendarContextData {
  today: Date;
  currentDate: Date;
  currentStartOfWeek: Date;
  currentMonth: number;
  currentYear: number;
  setCurrentDate: (currentDate: Date) => void;
  setCurrentStartOfWeek: (currentSunday: Date) => void;
  setCurrentMonth: (currentMonth: number) => void;
  setCurrentYear: (currentMonth: number) => void;
  resetCalendar: () => void;
}

export const CalendarContext = createContext<CalendarContextData>({
  today: new Date(),
  currentDate: new Date(),
  currentMonth: 0,
  currentYear: 0,
  currentStartOfWeek: getStartOfWeek(new Date()),

  setCurrentDate: () => {},
  setCurrentMonth: () => {},
  setCurrentYear: () => {},
  setCurrentStartOfWeek: () => {},
  resetCalendar: () => {},
});

export const CalendarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState<Date>(today);
  const [currentStartOfWeek, setCurrentStartOfWeek] = useState<Date>(
    getStartOfWeek(new Date())
  );
  const [currentMonth, setCurrentMonth] = useState<number>(today.getMonth());
  const [currentYear, setCurrentYear] = useState<number>(today.getFullYear());

  const resetCalendar = () => {
    setCurrentDate(today);
    setCurrentMonth(today.getMonth());
    setCurrentYear(today.getFullYear());
    setCurrentStartOfWeek(getStartOfWeek(new Date()));
  };

  return (
    <CalendarContext.Provider
      value={{
        today,
        currentDate,
        currentStartOfWeek,
        currentMonth,
        currentYear,
        setCurrentDate,
        setCurrentStartOfWeek,
        setCurrentMonth,
        setCurrentYear,
        resetCalendar,
      }}
    >
      {children}
    </CalendarContext.Provider>
  );
};
